<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.71309 40.8324C-6.0344 32.6686 7.53162 6.80835 26.8058 3.53305C48.4274 -0.157773 63.5996 15.8765 59.8436 34.3551C55.7169 54.7402 28.5108 64.9327 20.7764 57.6977C16.2297 53.4447 23.8158 48.2385 18.2065 43.0078C12.5973 37.7771 6.79031 44.6698 2.71309 40.8568V40.8324Z"
      fill="var(--v-illustrations-lighten2)"
    />
    <path
      d="M53.9981 53L54.0134 45"
      stroke="#797997"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M50 49H58"
      stroke="#797997"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M24 11L18 5"
      stroke="var(--v-illustrations-darken1)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 11L24 5"
      stroke="var(--v-illustrations-darken1)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M61 33C62.6569 33 64 31.6569 64 30C64 28.3431 62.6569 27 61 27C59.3431 27 58 28.3431 58 30C58 31.6569 59.3431 33 61 33Z"
      stroke="#797997"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M28.5 35.5L8 25L50 17L28.5 35.5Z"
      fill="var(--v-illustrations-lighten3)"
      stroke="var(--v-illustrations-darken1)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28 36L33.907 57L50 17L28 36Z"
      fill="var(--v-illustrations-lighten1)"
      stroke="#797997"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.3155 45.2565C15.3155 45.2565 15.2907 45.2565 15.266 45.2565C14.7965 45.9165 14.3023 46.9919 13.4869 47.0653C12.6714 47.1386 12.2761 46.9919 11.7324 46.4786C11.1888 45.9654 11.0405 45.3787 10.9417 44.5477C10.8429 43.7166 11.09 42.6167 11.5595 41.859C12.0043 41.1013 12.968 40.7102 13.5857 40.6369C14.2035 40.5635 14.2282 40.6858 14.5741 40.808C14.9448 40.9546 14.8707 41.2724 15.1672 41.419C15.1919 41.419 15.1672 41.4679 15.1919 41.419C15.2907 41.1746 15.1919 40.8813 15.1919 40.588C15.1919 40.2947 15.3155 40.3191 15.612 40.2214C15.9085 40.0991 16.0815 40.588 16.0815 40.6124C15.9826 41.2479 16.0815 44.3033 16.0815 44.3521C16.1803 45.4521 16.5757 45.9409 17.2676 45.9165C17.9595 45.892 18.2066 45.5987 18.5278 44.9632C18.849 44.3277 19.022 43.8144 19.0467 42.8123C19.0714 41.8101 18.7008 40.3436 17.5641 39.537C16.4274 38.7548 15.0436 38.1682 13.4622 38.2904C11.8807 38.4126 10.3239 39.317 9.38495 40.588C8.44595 41.859 8.19885 43.35 8.29769 44.7921C8.39653 46.2342 9.06371 47.383 10.1263 48.3118C11.1641 49.2407 12.8691 49.5095 14.0799 49.4362C15.2907 49.3629 15.8344 48.9718 16.8475 48.5563C16.9711 48.5074 17.3664 48.4585 17.4405 48.7762C17.5147 49.094 16.2544 49.7556 15.612 50C14.9448 50.2444 14.7224 50.2428 14.1294 50.3161C12.8938 50.4383 10.6452 50.0717 9.48379 48.9962C8.3224 47.9208 7.40811 46.6497 7.33398 44.9388C7.25985 43.2522 7.40811 41.5413 8.66835 40.0747C9.92858 38.6081 11.3618 37.8504 13.5857 37.4593C14.8954 37.2394 16.971 37.9482 18.2066 38.877C19.4174 39.8058 20.0104 41.7368 19.9116 42.9589C19.8127 44.181 19.7386 44.6699 19.3185 45.5254C18.8738 46.3564 18.3548 46.6742 17.4405 46.772C16.5263 46.8697 15.9826 45.8187 15.3649 45.281L15.3155 45.2565ZM13.7587 41.4679C12.968 41.5412 12.7209 41.859 12.3502 42.4212C11.9795 42.9834 11.9054 43.9122 11.9548 44.4988C12.0043 45.0854 12.1031 45.4521 12.4243 45.8187C12.7703 46.1609 12.9927 46.2831 13.5363 46.2098C14.0799 46.1609 14.5494 45.8676 14.8212 45.2321C15.0931 44.5721 15.1919 43.6922 15.1425 42.8856C15.0931 42.079 14.5494 41.419 13.7587 41.4924V41.4679Z"
      fill="#797997"
      stroke="#797997"
      stroke-width="0.611063"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>